export const STATUS_LABELS = {
  submitted: { label: "Ko'rib chiqilmoqda", color: 'bg-amber-50 text-amber-700 ring-amber-600/20' },
  under_review: { label: 'Taqrizda', color: 'bg-blue-50 text-blue-700 ring-blue-600/20' },
  revision_required: { label: 'Qayta ishlash kerak', color: 'bg-orange-50 text-orange-700 ring-orange-600/20' },
  accepted: { label: 'Qabul qilindi', color: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20' },
  rejected: { label: 'Rad etildi', color: 'bg-red-50 text-red-700 ring-red-600/20' },
  published: { label: 'Chop etildi', color: 'bg-violet-50 text-violet-700 ring-violet-600/20' },
};

export const PAYMENT_LABELS = {
  none: { label: '-', color: 'bg-slate-50 text-slate-500' },
  pending: { label: "To'lov kutilmoqda", color: 'bg-amber-50 text-amber-700 ring-amber-600/20', icon: '⏳' },
  receipt_uploaded: { label: "Chek yuklangan", color: 'bg-blue-50 text-blue-700 ring-blue-600/20', icon: '🧾' },
  confirmed: { label: "To'lov tasdiqlangan", color: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20', icon: '✅' },
  waived: { label: "To'lovdan ozod", color: 'bg-cyan-50 text-cyan-700 ring-cyan-600/20', icon: '🆓' },
  rejected: { label: "To'lov rad etildi", color: 'bg-red-50 text-red-700 ring-red-600/20', icon: '❌' },
};

export function StatusBadge({ status }) {
  const info = STATUS_LABELS[status] || { label: status, color: 'bg-slate-50 text-slate-600 ring-slate-500/20' };
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium ring-1 ring-inset ${info.color}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${info.color.includes('amber') ? 'bg-amber-500' : info.color.includes('blue') ? 'bg-blue-500' : info.color.includes('orange') ? 'bg-orange-500' : info.color.includes('emerald') ? 'bg-emerald-500' : info.color.includes('red') ? 'bg-red-500' : info.color.includes('violet') ? 'bg-violet-500' : 'bg-slate-500'}`} />
      {info.label}
    </span>
  );
}

export function PaymentBadge({ status }) {
  if (!status || status === 'none') return null;
  const info = PAYMENT_LABELS[status] || { label: status, color: 'bg-slate-50 text-slate-600', icon: '' };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-medium ring-1 ring-inset ${info.color}`}>
      {info.icon && <span>{info.icon}</span>}
      {info.label}
    </span>
  );
}
